import React from 'react';
import { observer } from 'mobx-react';
import VirtualizedTable from '../common/VirtualizedTable';

export default observer(props => {
  const { height, width, items, onClickItem } = props
  const columns = [
    { key: 'code', label: 'Code', width: 60 },
    { key: 'name', label: 'Customer name', width: 250 },
    { key: 'contact', label: 'Contact', width: 150, hideBelowWidth: 680 },
  ]
  return <VirtualizedTable 
    height={height}
    width={width}
    items={items}
    onClickItem={onClickItem}
    columns={columns}
  />
})


// WEBPACK FOOTER //
// ./src/components/customers/CustomerTable.js